export default "__VITE_ASSET__CZsWvGzn__"